import { TabPanel } from "@mui/lab";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useTabSearchParams from "@entrilia/shared/hooks/useTabSearchParams";
import GeneralPageHeader from "../../common/GeneralPageHeader";
import PageTabs from "../../common/PageTabs";
import PendingApprovalsList from "./PendingApprovalsList";
import ReviewedApprovalsList from "./ReviewedApprovalsList";

const tabValues = ["for-me", "requested-by-me", "reviewed-by-me"] as const;

const tabPanelSx = { flex: 1, px: 3, pt: 2.5, width: "100%" };

const ApprovalsPage = () => {
  usePageTitle("Approvals");

  const { selectedTab, onTabChange } = useTabSearchParams(tabValues);

  return (
    <>
      <GeneralPageHeader title="Approvals" hideBorderLine />

      <PageTabs
        tabs={tabValues}
        labels={["Pending my approval", "Requested by me", "Reviewed by me"]}
        value={selectedTab}
        onChange={onTabChange}
      >
        <TabPanel value="for-me" sx={tabPanelSx}>
          <PendingApprovalsList target="for-me" />
        </TabPanel>
        <TabPanel value="requested-by-me" sx={tabPanelSx}>
          <PendingApprovalsList target="requested-by-me" />
        </TabPanel>
        <TabPanel value="reviewed-by-me" sx={tabPanelSx}>
          <ReviewedApprovalsList />
        </TabPanel>
      </PageTabs>
    </>
  );
};

export default ApprovalsPage;
